import React from 'react';
import { AlertTriangle, AlertCircle, Info, CheckCircle } from 'lucide-react';
import { BugReportStats as Stats, Criticidade } from '../../services/bugReportService';

interface Props {
  stats: Stats | null;
  onFilterClick?: (criticidade: Criticidade) => void;
}

export const BugReportStats: React.FC<Props> = ({ stats, onFilterClick }) => {
  if (!stats) return null;

  const cards = [
    {
      label: 'Critica',
      value: stats.por_criticidade.CRITICA || 0,
      icon: AlertTriangle,
      color: 'red',
      crit: 'CRITICA' as Criticidade,
    },
    {
      label: 'Alta',
      value: stats.por_criticidade.ALTA || 0,
      icon: AlertCircle,
      color: 'orange',
      crit: 'ALTA' as Criticidade,
    },
    {
      label: 'Media',
      value: stats.por_criticidade.MEDIA || 0,
      icon: Info,
      color: 'amber',
      crit: 'MEDIA' as Criticidade,
    },
    {
      label: 'Baixa',
      value: stats.por_criticidade.BAIXA || 0,
      icon: CheckCircle,
      color: 'gray',
      crit: 'BAIXA' as Criticidade,
    },
  ];

  const colorClass = (color: string) => {
    switch (color) {
      case 'red':
        return 'bg-red-50 border-red-300 text-red-900 hover:bg-red-100';
      case 'orange':
        return 'bg-orange-50 border-orange-300 text-orange-900 hover:bg-orange-100';
      case 'amber':
        return 'bg-amber-50 border-amber-300 text-amber-900 hover:bg-amber-100';
      default:
        return 'bg-gray-50 border-gray-300 text-gray-900 hover:bg-gray-100';
    }
  };

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(({ label, value, icon: Icon, color, crit }) => (
          <button
            key={label}
            type="button"
            onClick={() => onFilterClick?.(crit)}
            className={`flex items-center justify-between p-4 rounded-lg border-2 transition-colors text-left ${colorClass(color)}`}
          >
            <div>
              <div className="text-xs font-semibold uppercase tracking-wide opacity-75">{label}</div>
              <div className="text-3xl font-bold mt-1">{value}</div>
            </div>
            <Icon className="w-10 h-10 opacity-60" />
          </button>
        ))}
      </div>
      {stats.criticos_abertos > 0 && (
        <div className="mt-3 p-3 bg-red-50 border-l-4 border-red-500 rounded">
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-red-600" />
            <span className="text-sm font-semibold text-red-800">
              {stats.criticos_abertos} bug{stats.criticos_abertos !== 1 ? 's' : ''} critico{stats.criticos_abertos !== 1 ? 's' : ''} aberto{stats.criticos_abertos !== 1 ? 's' : ''} — atencao imediata necessaria
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
